import { useState } from 'react'
import { FileInput } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { MODULES, useModules } from '@/hooks/useModules'

import { WinnerImportDialog } from './WinnerImportDialog'
import type { WinnerImportResult } from './winner-import.api'

type Props = {
  testId: string
  size?: 'default' | 'sm'
  entryProject?: { id: string; name: string | null }
  onImported?: (result: WinnerImportResult) => void
}

/** The door to the Winner import, drawn only for organisations with the module. */
export function WinnerImportButton({ testId, size = 'default', entryProject, onImported }: Props) {
  const { hasModule } = useModules()
  const [open, setOpen] = useState(false)

  if (!hasModule(MODULES.QUOTE_IMPORT)) return null

  return (
    <>
      <Button variant="outline" size={size} className="gap-2" data-testid={testId} onClick={() => setOpen(true)}>
        <FileInput className="h-4 w-4" />
        {entryProject ? 'Importer un devis Winner' : 'Importer depuis Winner'}
      </Button>
      <WinnerImportDialog open={open} onOpenChange={setOpen} entryProject={entryProject} onImported={onImported} />
    </>
  )
}
